import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input()
  title?: string;

  @Input()
  imageUrl?: string;

  @Input()
  disable?: boolean;

  @Output()
  action = new EventEmitter();

  onClick() {
    this.action.emit();
  }
}
